import hoistNonReactStatic from 'hoist-non-react-statics';
import {forOwn, isObject, isEmpty, keys} from 'lodash';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {useStore} from 'react-redux';

import {LIBRARY_NAME} from 'src/js/common/constants';
import {componentUtils, LogUtils} from 'src/js/common/utils/index';

const logger = LogUtils.getLogger('withReducers', LIBRARY_NAME);

const withReducers = (WrappedComponent) => {
  const WithReducers = (props) => {
    const store = useStore();
    const [initialized, setInitialized] = useState(false);
    const {reducers} = props;
    useEffect(() => {
      if (
        store &&
        store.injectReducer &&
        !isEmpty(reducers) &&
        isObject(reducers)
      ) {
        forOwn(reducers, (reducer, key) => {
          store.injectReducer(key, reducer);
        });
      } else {
        const reducerKeys =
          !isEmpty(reducers) && isObject(reducers) ? keys(reducers) : '';
        logger.warn(
          `Redux store injectReducer is not defined. Reducers "${reducerKeys}" were not added`
        );
      }
      setInitialized(true);
    }, [store, reducers]);

    // do not render WrappedComponent in the first render, because useEffect did not run yet
    return initialized ? <WrappedComponent {...props} /> : null;
  };

  WithReducers.displayName = `WithReducers(${componentUtils.getDisplayName(
    WrappedComponent
  )})`;
  WithReducers.WrappedComponent = WrappedComponent;

  WithReducers.contextTypes = {
    store: PropTypes.objectOf(PropTypes.any),
  };

  hoistNonReactStatic(WithReducers, WrappedComponent);

  return WithReducers;
};

export default withReducers;
